import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { RefundRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const requestRefund = createAsyncThunk<void, RefundRequestBody, { extra: Partial<Dependencies> }>(
  "refunds/requestRefund",
  async (refundRequest: RefundRequestBody, { extra: { studentRepository } }) => {
    return studentRepository!.requestRefund(refundRequest);
  },
);

export const resetRequestRefund = createAction("refunds/resetRequestRefund");
